import { mapData } from "@/stuff/DataMapping";

export interface ICertificateType {
    id: number;
    schemeID: number;
    type: string;
    description: string;
    displayOrder: number;
    archived: boolean;
    supplierValid: boolean;
    buyerValid: boolean;
}

export class CertificateType implements ICertificateType {

    constructor(data?: ICertificateType) {
        if (data) this.update(data);
    }

    update(data: ICertificateType): void {
        mapData(data, { root: () => this });
    }

    id: number = 0;
    schemeID: number = 0;
    type: string = "";
    description: string = "";
    displayOrder: number = 0;
    archived: boolean = false;

    supplierValid: boolean = false;
    buyerValid: boolean = false;

}